import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["highlightPattern", "label"];
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Highlighter from '../Highlight/Highlighter';
import ListboxOption from '../Listbox/ListboxOption';
import { ComboboxOptionMixin } from '../../mixins/components/ComboboxOptionMixin';
export var StyledComboboxOption = /*#__PURE__*/styled(ListboxOption).withConfig({
  displayName: "StyledComboboxOption",
  componentId: "c11n-8-64-0__sc-brr3vr-0"
})(["", ""], ComboboxOptionMixin);
/**
 * An option component for the [`Combobox`](#/Form%20components?id=combobox)
 * dropdown [`Listbox`](#/Form%20components?id=listbox).  This is the same
 * as [`ListboxOption`](#/Form%20components?id=listboxoption) with the added ability to highlight
 * matching parts of the `label`.
 *
 * @since 8.28.0
 */

var ComboboxOption = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var highlightPattern = _ref.highlightPattern,
      label = _ref.label,
      rest = _objectWithoutProperties(_ref, _excluded);

  var labelNode = label;

  if (label && highlightPattern) {
    labelNode = /*#__PURE__*/React.createElement(Highlighter, {
      text: label,
      pattern: highlightPattern
    });
  }

  return /*#__PURE__*/React.createElement(StyledComboboxOption, _extends({
    ref: ref,
    label: labelNode
  }, rest));
});
ComboboxOption.displayName = 'ComboboxOption';
ComboboxOption.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Highlight the matched part of an option `label`.
   *
   * See [`Highlighter`](#/More%20components?id=highlighter) for more info.
   */
  highlightPattern: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(RegExp)]),

  /**
   * The label to display for this option.
   */
  label: PropTypes.string
} : {};
export default ComboboxOption;